/*
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-07-22 15:13:49
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-21 14:36:49
 */

let apiPath = '' // 数据API
let fileUrl = 'http://dfs.cricbigdata.com' // 文件系统,上传upload，预览view，下载download
let loginUrl = '' // 登录地址

if (process.env.NODE_ENV === 'development') {
    loginUrl = 'https://yuntest.cricyun.com/'
    fileUrl = 'http://dfs.renttest.dev.cricwifi.com'
    // apiPath = 'http://yuntudc.xmq.dev.cricwifi.com/api'

    apiPath = 'http://yuntudc.renttest.dev.cricwifi.com/api'
    // apiPath = 'http://10.122.149.203:9999/mock/14/api'

    // apiPath = 'http://yuntudc.xmq.dev.cricwifi.com/api'
    // apiPath = 'http://yuntudc.dudl.dev.cricwifi.com/api'
    // apiPath = 'http://yuntudc.zhanghf.dev.cricwifi.com/api'
    // apiPath = 'http://yuntudc.wjj.dev.cricwifi.com/api'
} else if (process.env.NODE_ENV === 'production') {
    loginUrl = 'https://yuntudc.cricbigdata.com/'
    fileUrl = 'http://dfs.cricbigdata.com'
    apiPath = 'http://yuntudc.cricbigdata.com/api'
}

export default {
    loginUrl,
    apiPath,
    fileUrl
}
